import {ClickEvent} from "../../../infrastructure/models/analytics/click-event";
import {Type} from "../../../infrastructure/type";
import {EntityViewModel} from "../../../infrastructure/models/entity/entity.view-model";
import {APP} from "../../app/consts";

export class BracketsStageClickEvent extends ClickEvent {
  entityType: Type<EntityViewModel>;
  entityId: Number;
  competitionId: Number;
  source: APP.ANALYTICS.SOURCES;
  sportTypeId: Number;
  stageNum: Number;

  constructor(params) {
    super('', 'click', 'brackets-stage');

    this.entityType = params.entityType;
    this.entityId = params.entityId;
    this.competitionId = params.competitionId;
    this.source = params.source;
    this.sportTypeId = params.sportTypeId;
    this.stageNum = params.stageNum;
  }

  get properties() {
    const properties = super.properties;

    properties.entityType = this.entityType;
    properties.entityId = this.entityId;
    properties.competitionId = this.competitionId;
    properties.source = this.source;
    properties.sportTypeId = this.sportTypeId;
    properties.stageNum = this.stageNum;

    return properties;
  }
}
